import styled from '@emotion/styled';
import React from 'react';

import { clsx } from '../../lib/clsx';

import { su } from '../../theme/functions/su';
import { theme } from '../../theme/theme';

import { useSectionContext } from './ListBox';

export function ListBoxSection(props) {
  const {
    section,
    item,
    children,
    sectionClassName,
    sectionHeadingWrapperClassName,
    sectionHeadingClassName,
    sectionListClassName,
  } = useSectionContext();

  const HeadingComponent = props.headingComponent ?? S.Heading;
  const rootClassName = clsx(section.itemProps.className, sectionClassName, props.className);
  const headingWrapperClassName = clsx(
    sectionHeadingWrapperClassName,
    props.headingWrapperClassName,
  );
  const headingClassName = clsx(
    section.headingProps.className,
    sectionHeadingClassName,
    props.headingClassName,
  );
  const listClassName = clsx(
    section.groupProps.className,
    sectionListClassName,
    props.listClassName,
  );

  return (
    <S.Root {...section.itemProps} className={rootClassName} style={props.style} as={props.as}>
      {item.rendered && (
        <S.HeadingRoot className={headingWrapperClassName}>
          <S.HeadingWrapper>
            <HeadingComponent {...section.headingProps} className={headingClassName}>
              {item.rendered}
            </HeadingComponent>
          </S.HeadingWrapper>
        </S.HeadingRoot>
      )}

      <S.List {...section.groupProps} className={listClassName}>
        {children}
      </S.List>
    </S.Root>
  );
}

function S() {}
ListBoxSection.S = S;

S.Root = styled.li`
  &:not(:last-of-type) {
    padding-bottom: ${su(2)};
  }
`;

S.HeadingRoot = styled.div``;

S.HeadingWrapper = styled.div`
  padding-inline-start: ${su(1)};
  padding-bottom: ${su(1)};
`;

S.Heading = styled.div`
  font-size: ${theme.fontSize.small};
  color: ${theme.color.text_light};
`;

S.List = styled.ul`
  list-style: none;
`;
